/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  RichiestaPreventivoCreateResponseDto,
  RichiestaPreventivoCreateDto,
  RichiestaPreventivoDto,
  GetRichiestePreventivoParams,
  ProblemDetails,
  RichiestaPreventivoUpdateUserCommercialeDto,
  RichiestaPreventivoUpdateVuoleEssereRicontattatoDto,
} from ".././models";

export const createRichiestaPreventivo = (
  richiestaPreventivoCreateDto: RichiestaPreventivoCreateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RichiestaPreventivoCreateResponseDto>> => {
  return axios.post(
    `/api/richieste_preventivo`,
    richiestaPreventivoCreateDto,
    options
  );
};

export const getCreateRichiestaPreventivoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRichiestaPreventivo>>,
    TError,
    { data: RichiestaPreventivoCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRichiestaPreventivo>>,
  TError,
  { data: RichiestaPreventivoCreateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRichiestaPreventivo>>,
    { data: RichiestaPreventivoCreateDto }
  > = (props) => {
    const { data } = props ?? {};

    return createRichiestaPreventivo(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRichiestaPreventivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRichiestaPreventivo>>
>;
export type CreateRichiestaPreventivoMutationBody =
  RichiestaPreventivoCreateDto;
export type CreateRichiestaPreventivoMutationError = AxiosError<unknown>;

export const useCreateRichiestaPreventivo = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRichiestaPreventivo>>,
    TError,
    { data: RichiestaPreventivoCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getCreateRichiestaPreventivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getRichiestePreventivo = (
  params?: GetRichiestePreventivoParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RichiestaPreventivoDto[]>> => {
  return axios.get(`/api/richieste_preventivo`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetRichiestePreventivoQueryKey = (
  params?: GetRichiestePreventivoParams
) => [`/api/richieste_preventivo`, ...(params ? [params] : [])] as const;

export const getGetRichiestePreventivoQueryOptions = <
  TData = Awaited<ReturnType<typeof getRichiestePreventivo>>,
  TError = AxiosError<unknown>
>(
  params?: GetRichiestePreventivoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestePreventivo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getRichiestePreventivo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRichiestePreventivoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRichiestePreventivo>>
  > = ({ signal }) =>
    getRichiestePreventivo(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetRichiestePreventivoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRichiestePreventivo>>
>;
export type GetRichiestePreventivoQueryError = AxiosError<unknown>;

export const useGetRichiestePreventivo = <
  TData = Awaited<ReturnType<typeof getRichiestePreventivo>>,
  TError = AxiosError<unknown>
>(
  params?: GetRichiestePreventivoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestePreventivo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRichiestePreventivoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateRichiestaPreventivoUserCommerciale = (
  id: number,
  richiestaPreventivoUpdateUserCommercialeDto: RichiestaPreventivoUpdateUserCommercialeDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RichiestaPreventivoDto>> => {
  return axios.put(
    `/api/richieste_preventivo/${id}/user_commerciale`,
    richiestaPreventivoUpdateUserCommercialeDto,
    options
  );
};

export const getUpdateRichiestaPreventivoUserCommercialeMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRichiestaPreventivoUserCommerciale>>,
    TError,
    { id: number; data: RichiestaPreventivoUpdateUserCommercialeDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRichiestaPreventivoUserCommerciale>>,
  TError,
  { id: number; data: RichiestaPreventivoUpdateUserCommercialeDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRichiestaPreventivoUserCommerciale>>,
    { id: number; data: RichiestaPreventivoUpdateUserCommercialeDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRichiestaPreventivoUserCommerciale(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRichiestaPreventivoUserCommercialeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateRichiestaPreventivoUserCommerciale>>
  >;
export type UpdateRichiestaPreventivoUserCommercialeMutationBody =
  RichiestaPreventivoUpdateUserCommercialeDto;
export type UpdateRichiestaPreventivoUserCommercialeMutationError =
  AxiosError<ProblemDetails>;

export const useUpdateRichiestaPreventivoUserCommerciale = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRichiestaPreventivoUserCommerciale>>,
    TError,
    { id: number; data: RichiestaPreventivoUpdateUserCommercialeDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions =
    getUpdateRichiestaPreventivoUserCommercialeMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getRichiestaPreventivoById = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RichiestaPreventivoDto>> => {
  return axios.get(`/api/richieste_preventivo/${id}`, options);
};

export const getGetRichiestaPreventivoByIdQueryKey = (id: number) =>
  [`/api/richieste_preventivo/${id}`] as const;

export const getGetRichiestaPreventivoByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRichiestaPreventivoById>>,
  TError = AxiosError<ProblemDetails>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestaPreventivoById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getRichiestaPreventivoById>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRichiestaPreventivoByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRichiestaPreventivoById>>
  > = ({ signal }) =>
    getRichiestaPreventivoById(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetRichiestaPreventivoByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRichiestaPreventivoById>>
>;
export type GetRichiestaPreventivoByIdQueryError = AxiosError<ProblemDetails>;

export const useGetRichiestaPreventivoById = <
  TData = Awaited<ReturnType<typeof getRichiestaPreventivoById>>,
  TError = AxiosError<ProblemDetails>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestaPreventivoById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRichiestaPreventivoByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const deleteRichiestaPreventivo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/api/richieste_preventivo/${id}`, options);
};

export const getDeleteRichiestaPreventivoMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRichiestaPreventivo>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRichiestaPreventivo>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRichiestaPreventivo>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRichiestaPreventivo(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRichiestaPreventivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRichiestaPreventivo>>
>;

export type DeleteRichiestaPreventivoMutationError = AxiosError<ProblemDetails>;

export const useDeleteRichiestaPreventivo = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRichiestaPreventivo>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getDeleteRichiestaPreventivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getRichiestaPreventivoByToken = (
  token: string,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RichiestaPreventivoDto>> => {
  return axios.get(`/api/richieste_preventivo/token/${token}`, options);
};

export const getGetRichiestaPreventivoByTokenQueryKey = (token: string) =>
  [`/api/richieste_preventivo/token/${token}`] as const;

export const getGetRichiestaPreventivoByTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>,
  TError = AxiosError<ProblemDetails>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRichiestaPreventivoByTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>
  > = ({ signal }) =>
    getRichiestaPreventivoByToken(token, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!token, ...queryOptions };
};

export type GetRichiestaPreventivoByTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>
>;
export type GetRichiestaPreventivoByTokenQueryError =
  AxiosError<ProblemDetails>;

export const useGetRichiestaPreventivoByToken = <
  TData = Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>,
  TError = AxiosError<ProblemDetails>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestaPreventivoByToken>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRichiestaPreventivoByTokenQueryOptions(
    token,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateVuoleEssereRicontattato = (
  token: string,
  richiestaPreventivoUpdateVuoleEssereRicontattatoDto: RichiestaPreventivoUpdateVuoleEssereRicontattatoDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RichiestaPreventivoDto>> => {
  return axios.put(
    `/api/richieste_preventivo/token/${token}`,
    richiestaPreventivoUpdateVuoleEssereRicontattatoDto,
    options
  );
};

export const getUpdateVuoleEssereRicontattatoMutationOptions = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVuoleEssereRicontattato>>,
    TError,
    {
      token: string;
      data: RichiestaPreventivoUpdateVuoleEssereRicontattatoDto;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVuoleEssereRicontattato>>,
  TError,
  { token: string; data: RichiestaPreventivoUpdateVuoleEssereRicontattatoDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVuoleEssereRicontattato>>,
    { token: string; data: RichiestaPreventivoUpdateVuoleEssereRicontattatoDto }
  > = (props) => {
    const { token, data } = props ?? {};

    return updateVuoleEssereRicontattato(token, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVuoleEssereRicontattatoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVuoleEssereRicontattato>>
>;
export type UpdateVuoleEssereRicontattatoMutationBody =
  RichiestaPreventivoUpdateVuoleEssereRicontattatoDto;
export type UpdateVuoleEssereRicontattatoMutationError =
  AxiosError<ProblemDetails>;

export const useUpdateVuoleEssereRicontattato = <
  TError = AxiosError<ProblemDetails>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVuoleEssereRicontattato>>,
    TError,
    {
      token: string;
      data: RichiestaPreventivoUpdateVuoleEssereRicontattatoDto;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions =
    getUpdateVuoleEssereRicontattatoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getRichiestaPreventivoFilePdfByToken = (
  token: string,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(
    `/api/richieste_preventivo/token/${token}/file_pdf`,
    options
  );
};

export const getGetRichiestaPreventivoFilePdfByTokenQueryKey = (
  token: string
) => [`/api/richieste_preventivo/token/${token}/file_pdf`] as const;

export const getGetRichiestaPreventivoFilePdfByTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>,
  TError = AxiosError<ProblemDetails>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRichiestaPreventivoFilePdfByTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>
  > = ({ signal }) =>
    getRichiestaPreventivoFilePdfByToken(token, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!token, ...queryOptions };
};

export type GetRichiestaPreventivoFilePdfByTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>
>;
export type GetRichiestaPreventivoFilePdfByTokenQueryError =
  AxiosError<ProblemDetails>;

export const useGetRichiestaPreventivoFilePdfByToken = <
  TData = Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>,
  TError = AxiosError<ProblemDetails>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRichiestaPreventivoFilePdfByToken>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRichiestaPreventivoFilePdfByTokenQueryOptions(
    token,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useCreateRichiestaPreventivo = () =>
  //@ts-ignore
  useCreateRichiestaPreventivo(...([] as any[]));

export const __$$useGetRichiestePreventivo = () =>
  //@ts-ignore
  useGetRichiestePreventivo(...([] as any[]));

export const __$$useUpdateRichiestaPreventivoUserCommerciale = () =>
  //@ts-ignore
  useUpdateRichiestaPreventivoUserCommerciale(...([] as any[]));

export const __$$useGetRichiestaPreventivoById = () =>
  //@ts-ignore
  useGetRichiestaPreventivoById(...([] as any[]));

export const __$$useDeleteRichiestaPreventivo = () =>
  //@ts-ignore
  useDeleteRichiestaPreventivo(...([] as any[]));

export const __$$useGetRichiestaPreventivoByToken = () =>
  //@ts-ignore
  useGetRichiestaPreventivoByToken(...([] as any[]));

export const __$$useUpdateVuoleEssereRicontattato = () =>
  //@ts-ignore
  useUpdateVuoleEssereRicontattato(...([] as any[]));

export const __$$useGetRichiestaPreventivoFilePdfByToken = () =>
  //@ts-ignore
  useGetRichiestaPreventivoFilePdfByToken(...([] as any[]));
